import React from 'react';

const QuizHeader = () => (
  <div className="w-full bg-[#88C0FF] h-[60px] md:h-[68px] px-4 md:pl-4 flex items-center mb-4 md:mb-6 shadow-sm animate-in fade-in duration-500">
    <div className="flex items-center gap-[8px] md:gap-[10px]">
      <span className="bg-[#21C11E] text-white text-[13px] md:text-[16px] tracking-tight font-[500] py-[6px] md:py-[10px] px-[10px] md:px-[15px] rounded-[3px] font-inter whitespace-nowrap shadow-sm">
        FREE
      </span>
      <h1 className="text-[#333333] font-inter text-[18px] sm:text-[21px] md:text-[24px] font-[500] tracking-tight leading-tight">
        Daily Online Quizzes
      </h1>
    </div>
    
  </div>
);

export default QuizHeader;